// services/medications.js
import api from "./apiClient";

// Get all medications
const getAllMedications = () => {
  return api.get(`/api/medications`);
};

// Get medication by ID
const getMedicationById = (id: any) => {
  return api.get(`/api/medications/${id}`);
};

// Create a new medication
const createMedication = (data: any) => {
  return api.post(`/api/medications`, data);
};

// Update a medication
const updateMedication = (id: any, data: any) => {
  return api.put(`/api/medications/${id}`, data);
};

// Delete a medication
const deleteMedication = (id: any) => {
  return api.delete(`/api/medications/${id}`);
};

// Import medications from file (CSV/Excel)
const importMedications = (formData: any) => {
  return api.post(`/api/medications/import`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

// Assign medication to facility
const assignMedicationToFacility = (medicationId: any, facilityId: any) => {
  return api.post(`/api/medications/${medicationId}/facilities/${facilityId}`);
};

// Remove medication from facility
const removeMedicationFromFacility = (medicationId: any, facilityId: any) => {
  return api.delete(`/api/medications/${medicationId}/facilities/${facilityId}`);
};

// Get facility with all its medications
const getFacilityWithMedications = (facilityId: any) => {
  return api.get(`/api/facilities/${facilityId}/medications`);
};

const findFacilitiesWithMedication = (medicationId: any) => {
  return api.get(`/api/medications/${medicationId}/facilities`);
};

export {
  getAllMedications,
  getMedicationById,
  createMedication,
  updateMedication,
  deleteMedication,
  importMedications,
  assignMedicationToFacility,
  removeMedicationFromFacility,
  getFacilityWithMedications,
  findFacilitiesWithMedication
};